import '@/assets.best-books/styles.scss'
import '@/assets.best-books/book-list-page.scss'
import '@/assets.v2/css/iconfont/iconfont.css'

// Manages public page navbar toggling on small screen.
// eslint-disable-next-line import/no-unassigned-import
import '@/assets.best-books/bootstrap/js/collapse.js'
import { initPageBestBooks } from '@/pages-best-books/init'

initPageBestBooks()
